import { render, staticRenderFns } from "./basemanufacturerAction.vue?vue&type=template&id=6d4eb47a&scoped=true"
import script from "./basemanufacturerAction.vue?vue&type=script&lang=js"
export * from "./basemanufacturerAction.vue?vue&type=script&lang=js"
import style0 from "./basemanufacturerAction.vue?vue&type=style&index=0&id=6d4eb47a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4eb47a",
  null
  
)

export default component.exports